/**
 * @file index.tsx
 * @module app/modules/advertisement/index
 * @description Implements the index workflow for creating, reviewing, and managing UTrade Admin advertising campaigns.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { Navigate, Outlet, Route, Routes } from "react-router-dom";
import { PageLink, PageTitle } from "../../../_admin/layout/core";

import ViewAdvertisement from "./view-advertisement";
import AddNewAdvertisement from "./add-new-advertisement";
import AdvertisementDetails from "./advertising-details";
const advertisementBreadCrumbs: Array<PageLink> = [
  {
    title: "Advertisement",
    path: "/advertisement",
    isSeparator: false,
    isActive: false,
  },
  {
    title: "",
    path: "",
    isSeparator: true,
    isActive: false,
  },
];
const AdvertisementPage = () => (
  <Routes>
    <Route element={<Outlet />}>
      <Route
        path="view-advertisement"
        element={
          <>
            <PageTitle breadcrumbs={advertisementBreadCrumbs}>View Advertisement</PageTitle>
            <ViewAdvertisement />
          </>
        }
      />

      <Route
        path="add-new-advertisement"
        element={
          <>
            <PageTitle breadcrumbs={advertisementBreadCrumbs}>
              Add New Advertisement
            </PageTitle>
            <AddNewAdvertisement />
          </>
        }
      />

      <Route
        path="view-advertisement/advertising-details"
        element={
          <>
            <PageTitle breadcrumbs={advertisementBreadCrumbs}>
              Advertising Details
            </PageTitle>
            <AdvertisementDetails />
          </>
        }
      />

      <Route
        index
        element={<Navigate to="/advertisement/view-advertisement" />}
      />
    </Route>
  </Routes>
);

export default AdvertisementPage;
